import { axios } from '@/utils/request';

let Api = {
  sendCode: '/user/login/verify-code', // 发送验证码
  verifyCode: '/verify_verification_code/', // 校验验证码
  userLogin: '/user/login', // 密码登录
  userInfo: '/user/curUserInfo', // 用户信息
  permissionDetail: '/auth/api/third-system/get-permission-detail-by-user', // 获取访问权限配额
};

// 发送验证码
export const sendCodeApi = (params) => {
  return axios.get(Api.sendCode, { params, headers: { Authorization: '' } });
};

// 校验验证码
export const verifyCodeApi = (params) => {
  return axios.post(Api.verifyCode, params);
};

// 密码登录
export const userLoginApi = (params) => {
  return axios.post(Api.userLogin, params);
}

// 用户信息
export const userInfoApi = (params) => {
  return axios.get(Api.userInfo, { params });
}

// 获取访问权限配额
export const permissionDetailApi = (params) => {
  return axios.get(Api.permissionDetail, { params });
};
